import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Typography } from 'ui-v2/components/Typography';
import Icon from 'ui-v2/components/Icon/Icon';
import parkplusStoreV2RedirectionRoutes from '../../constants/parkplusStoreV2RedirectionRoutes';
import { trackSearchClicked } from '../../utils/events';
import s from './Searchbar.module.scss';

export const Searchbar = ({ searchSuggestions = [] }) => {
  const router = useRouter();
  const [currentSuggestionIndex, setCurrentSuggestionIndex] = useState(0);

  useEffect(() => {
    if (searchSuggestions.length > 0) {
      const interval = setInterval(() => {
        setCurrentSuggestionIndex(
          (prevIndex) => (prevIndex + 1) % searchSuggestions.length
        );
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [searchSuggestions]);

  const label = searchSuggestions.length > 0
    ? searchSuggestions[currentSuggestionIndex]
    : "Search any product, deal, brand...";
  return (
    <div
      className={s.root}
      onClick={() => {
        router.push(`${parkplusStoreV2RedirectionRoutes.search}`);
        trackSearchClicked();
      }}
    >
      <div className={s.container}>
        <Icon name="SearchRegular" width={18} height={18} color="secondary" />
        <Typography
          label={label}
          color="placeholder"
          variant="label_3_medium"
          className={searchSuggestions.length > 0 ? s.suggestion : ''}
        />
      </div>
    </div>
  );
};
